<template>
  <div class="body">
    <!-- common -->
    <div class="common-page dark-theme">
      <div class="wrap">
        <h1 class="logo a11y-hidden"><img src="../assets/images/common/ci-wavve.png" alt="wavve" /></h1>
      </div>
      <div class="error-page">
        <img src="../assets/images/common/icon-error-74.png" alt="error" />
        <p class="error-txt01">
          웨이브에서 서비스점검 안내드립니다.
        </p>
        <p class="error-txt02">
          웨이브 서비스 점검으로 인해 현재 사이트를 사용하실 수 없습니다.<br />
          2017-10-18 06:00 이후부터 사용하실 수 있습니다.
          <span>웨이브를 이용해 주셔서 감사합니다.</span>
        </p>
      </div>
    </div>
    <!--// common -->
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
